import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const hotelService = {
  getAllHotels: async (filters = {}) => {
    const response = await axios.get(`${API_BASE_URL}/hotels`, {
      params: filters,
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getHotelById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/hotels/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  createHotel: async (hotelData) => {
    const response = await axios.post(
      `${API_BASE_URL}/hotels`,
      hotelData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  updateHotel: async (id, hotelData) => {
    const response = await axios.put(
      `${API_BASE_URL}/hotels/${id}`,
      hotelData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  deleteHotel: async (id) => {
    const response = await axios.delete(
      `${API_BASE_URL}/hotels/${id}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  },
};

export default hotelService;

